import { pickBy } from 'lodash'
import { useCallback } from 'react'
import { useApolloClient } from 'react-apollo-hooks'
import { Model, UseUpdateMutation, Data } from 'types/model'

/*
Description:
  useUpdate is an abstraction on top of the auto-generated useUpdateMutation.
  It adds handling of optimistic responses and uses a simpler function signature.

Parameters:
  __typename: __typename of model
  fragmentDoc: auto-generated fragment doc for model
  mutationName: mutation name
  useUpdateMutation: auto-generated useUpdateMutation for model
 */

export function useUpdate<M extends Model>(params: {
  __typename: string
  fragmentDoc: any
  mutationName: string
  useUpdateMutation: UseUpdateMutation<M>
}) {
  const update = params.useUpdateMutation()
  const client = useApolloClient()
  return useCallback(
    (id: string, data: Partial<Data<M>>) => {
      update({
        variables: {
          where: { id },
          data,
        },
        optimisticResponse() {
          const model = client.cache.readFragment<M>({
            id: `${params.__typename}:${id}`,
            fragment: params.fragmentDoc,
            fragmentName: params.__typename,
          })!
          return {
            __typename: 'Mutation',
            [params.mutationName]: {
              __typename: params.__typename,
              ...model,
              ...pickBy(data),
            },
          }
        },
      })
    },
    [params, update, client.cache],
  )
}
